import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import "./App.css";
import { BsFillCapslockFill } from "react-icons/bs";
import Main from "./containers/Main/Main";
import About from "./containers/About/About";
import Prices from "./containers/Prices/Prices";
import Projects from "./containers/Projects/Projects";
import Contacts from "./containers/Contacts/Contacts";
import YandexMetrika from "./components/YandexMetrika/YandexMetrika";
import GoogleAnalytics from "./components/GoogleAnalytics/GoogleAnalytics";
import SuccessPage from "./components/SuccessPage/SuccessPage";
import Header from "./components/Header/Header"; // Импортируем Header
import Footer from "./components/Footer/Footer"; // Импортируем Footer
import SocialMenu from "./components/SocialMenu/SocialMenu";

const App = () => {
  const location = useLocation();
  const [showToTopButton, setShowToTopButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleScroll = () => {
    setShowToTopButton(window.scrollY > 300);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isSuccessPage = location.pathname === "/success-page";

  return (
    <>
      <Header className={isSuccessPage ? "success-header" : ""} />

      <div>
        {showToTopButton && (
          <button className="to_top" onClick={scrollToTop}>
            <BsFillCapslockFill className="top_icon" />
          </button>
        )}
      </div>

      <TransitionGroup>
        <CSSTransition key={location.key} classNames="fade" timeout={400}>
          <Routes location={location}>
            <Route path="/" element={<Main />} />
            <Route path="/about" element={<About />} />
            <Route path="/services_prices" element={<Prices />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/success-page" element={<SuccessPage />} />
            <Route
              path="*"
              element={
                <div className="w-full h-[70vh] bg-black flex justify-center items-center">
                  <p className="text-white">Страница не найдена!</p>
                </div>
              }
            />
          </Routes>
        </CSSTransition>
      </TransitionGroup>
      <Footer />
      <SocialMenu />
      <GoogleAnalytics />
      <YandexMetrika />
    </>
  );
};

export default App;
